import api from './api';

// Configuración pública que el admin cambia desde el panel (endpoint público).
export const getPublicSettings = () =>
  api.get('/settings/public').then((r) => r.data.data);
